import { IonBackButton, IonCardContent, IonContent, IonLoading, IonPage, IonSelect, IonSelectOption } from "@ionic/react"
import { arrowBackCircleSharp } from "ionicons/icons"
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useParams } from 'react-router-dom';
import { ApplicationContext } from "../../ApplicationState";
import * as ApiService from "../../services/ApiService";
// import 'tabulator-tables/dist/css/tabulator.min.css';
// import 'survey-analytics/survey.analytics.tabulator.min.css';
import * as SurveyAnalytics from "survey-analytics";
import { Tabulator } from 'survey-analytics/survey.analytics.tabulator';
import { Model } from "survey-core";
import { PlotlySetup, VisualizationPanel, VisualizerBase } from "survey-analytics";
import "survey-analytics/survey.analytics.css";
import "./index.css";
import { Button, createTheme, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, formLabelClasses, ThemeProvider, Typography } from "@mui/material";
import MaterialTable from "material-table";
import tableIcons from "../Notifications/MaterialTableIcons";
import { useTranslations } from "../../hooks/useTranslations";


var _ = require("lodash");

// PlotlySetup.onPlotCreating.add((model, options) => {
//     options.layout.plot_bgcolor = "red"; //inner bar/pie only color
//     options.layout.paper_bgcolor = "gray"; //whole chart plot container color
// });


VisualizerBase.customColors = [
    "red",
    "blue",
    "#cd7eaf",
    "#a262a9",
    "#6f4d96",
    "#3d3b72",
    "#182844",
    "#6f4d96",
    "#3d3b72",
    "#182844",
];

export const ResultDetails: React.FC<any> = () => {

    const analyticsContainer = useRef(null);
    const defaultMaterialTheme = createTheme()
    const labels = useTranslations()

    const location: any = useLocation();
    const { userState } = useContext(ApplicationContext)
    const [selectedChartType, setSelectedChartType] = useState(labels.ByCharts);
    const [userData, setUserData] = useState([])

    const [userSurveyQuestions, setuserSurveyQuestions] = useState([])

    const tableRef = useRef(null)

    const { row } = location.state || {};

    const [surveyResult, setSurveyeesult] = useState([])
    const [loading, setLoading] = useState(false)
    const [responseCount, setResponseCount] = useState(0)
    const [surveyUserCount, setSurveyUserCount] = useState(0)

    const [surveyDataTable, setSurveyDataTable] = useState(null);

    const chartTypes = [labels.ByUsers, labels.ByCharts];

    const groupsColumns = [
        {
            field: "name",
            title: labels.Username,
            width: 0
        },

        {
            field: "completedOn",
            title: labels.CompletedOn,
            width: 0
        },

        {
            field: "View Details",
            title: "",
            width: 0,
            render: rowData => {
                return (
                    <Button onClick={() => {
                        //handleDetails(rowData)
                    }} variant="contained">{labels.ViewDetails}</Button>
                )
            }
        },
    ];

    const ResultColumns = [
        {
            field: "Title",
            title: labels.Question,
            width: 0
        },

        {
            field: "Value",
            title: labels.Answer,
            width: 0
        },

        // {
        //     field: "Sentiment",
        //     title: "Sentiment",
        //     width: 0
        // }

        // {
        //     field: "See Sentiment",
        //     title: "",
        //     width: 0,
        //     render: rowData => {
        //         return (
        //             <Button onClick={() => {
        //                 seeSentiment(rowData)
        //             }} variant="contained">See Sentiment</Button>
        //         )
        //     }
        // },
    ];

    useEffect(() => {
        if (selectedChartType === labels.ByCharts) {
            getByCharts()
        } else {
            getByUser()
        }

    }, [selectedChartType])

    // const seeSentiment = (rowData) => {
    //     console.log("🚀 ~ seeSentiment ~ rowData:", rowData)

    //     ApiService.getSurveySentiment(userState.authenticatedUser, rowData.title, rowData.value).then((res) => {
    //         console.log("🚀 ~ ApiService.getSurveySentiment ~ res:", res)
    //     })
    // }

    const transformSurveyData = (surveypages, surveys) => {

        return surveypages.flatMap((page) =>
            page.elements
                .filter((element) => surveys[element.name] !== undefined)
                .map((element) => {

                    let value = surveys[element.name];

                    // Handle radiogroup choices
                    if (element.type === "radiogroup" && typeof value === "string") {
                        const choice = element.choices.find((c) => c.value === value);
                        value = choice?.text || value; // Map value to text if available

                    }

                    if (element.type === "checkbox") {
                        value = _.map(value, v => {
                            const choice = element.choices.find((c) => c.value === v);
                            return choice?.text || value; // Map value to text if available
                        })

                    }

                    if (element.type === "dropdown" && typeof value === "string") {
                        const choice = element.choices.find((c) => c.value === value);
                        value = choice?.text || value; // Map value to text if available

                    }

                    return {
                        name: element.name,
                        title: element.title,
                        value,
                    };
                })

        );
    }

    const getByUser = () => {
        setLoading(true)
        try {
            ApiService.getSurveyResultByUsers(userState.authenticatedUser, row.id).then((res) => {

                setLoading(false)
                if (res) {
                    const result = _.map(res, sur => {

                        const surveyResultWithSentiment = JSON.parse(sur?.surveyResultsWithSentiment)

                        const surveys = JSON.parse(sur?.surveyResults)
                        // const surveyJson = JSON.parse(row?.jsonData)
                        // const pages = surveyJson.pages
                        //const resultdata = transformSurveyData(pages, surveys)
                        // const survey = new Model(surveyJson);
                        // const surveyDataTable = new Tabulator(
                        //     survey,
                        //     [surveys]
                        // );

                        const data = {
                            name: sur?.users.firstName + sur?.users.lastName,
                            completedOn: sur?.completedOn,
                            surveyResult: surveys,
                            surveyDataToRender: surveyResultWithSentiment
                        }
                        return data
                    })
                    setUserData(result)
                }
            }).catch(err => {
                setLoading(false)
                alert(labels.Somethingwentwrong)
            })
        } catch (ex) {
            setLoading(false)
        }
    }

    const getByCharts = () => {
        setLoading(true)
        try {
            ApiService.getSurveyResultById(userState.authenticatedUser, row.id).then(res => {
                setLoading(false)
                if (res) {
                    const surveyJson = JSON.parse(row?.jsonData)
                    const survey = new Model(surveyJson);

                    const transformedResults = transformResults(res?.surveyResult)
                    setResponseCount(transformedResults.length)
                    setSurveyUserCount(res?.schedule?.length)
                    // Create a new SurveyAnalytics Tabulator instance
                    //const analytics = new SurveyAnalytics.Tabulator(surveyJson, transformedResults);

                    // const surveyDataTable = new Tabulator(
                    //     survey,
                    //     transformedResults
                    // );
                    // console.log("🚀 ~ ApiService.getSurveyResultById ~ surveyDataTable:", surveyDataTable)

                    const visPanel = new VisualizationPanel(
                        survey.getAllQuestions(),
                        transformedResults
                    );

                    // const visPanel = new SurveyAnalytics.VisualizationPanel(survey.getAllQuestions(), transformedResults, { defaultChartType: 'pie' });

                    // Render the analytics table
                    //surveyDataTable.render(analyticsContainer.current);


                    visPanel.render(analyticsContainer.current);

                }
            }).catch(error => {
                setLoading(false)
                alert(labels.Somethingwentwrong)
            })
        } catch (ex) {
            setLoading(false)
        }

    }

    // Transform database results for SurveyJS Analytics
    const transformResults = (resultsFromDb) => {
        return resultsFromDb.map((result) => {

            const surveyResponse = JSON.parse(result.surveyData);

            return {
                ...surveyResponse,
                CompletedOn: result.completedOn,
            };
        });
    };

    return (
        <IonPage>
            <IonContent style={{ backgroundColor: "white", overflow: "scroll", display: "flex" }}>
                <div style={{ display: "flex", justifyContent: 'space-between', alignItems: 'center', marginTop: 20 }}>
                    <IonBackButton
                        text={labels.Goback}
                        icon={arrowBackCircleSharp}
                        defaultHref="/"
                    />
                </div>
                <div style={{ display: "flex", justifyContent: "center", flexDirection: 'column', alignItems: 'center' }}>
                    <h1 style={{ color: "black" }}>{row?.surveyName}'s {labels.SurveyResults}</h1>
                    {
                        surveyUserCount > 0 ? (
                            <p style={{ color: "black" }}> {labels.basedon} {responseCount}/{surveyUserCount} {labels.Responsessinceitwascreatedon} {row?.createdOn}</p>

                        ) : (
                            <p style={{ color: "black" }}> {labels.Noresponsessinceitwascreatedon} {row?.createdOn}</p>
                        )
                    }
                    <IonSelect
                        style={{
                            height: 30,
                            borderRadius: 5,
                            width: 100,
                            borderColor: 'grey',
                            borderWidth: 1,
                            color: 'black',
                            backgroundColor: "lightgrey"
                        }}
                        value={selectedChartType}
                        placeholder="Select One"
                        onIonChange={(e) => {
                            setSelectedChartType(e.detail.value)
                        }}
                    >
                        {chartTypes?.map((type, index) => (
                            <IonSelectOption key={index} value={type}>
                                {type}
                            </IonSelectOption>
                        ))}
                    </IonSelect>
                </div>

                {
                    selectedChartType === labels.ByCharts && (
                        <div>
                            <div className="sa-question__select" ref={analyticsContainer} style={{ width: "100%", height: "600px" }}></div>
                        </div>
                    )
                }

                {
                    selectedChartType === labels.ByUsers && (
                        <IonCardContent>
                            <ThemeProvider theme={defaultMaterialTheme}>
                                <MaterialTable
                                    tableRef={tableRef}
                                    localization={{
                                        body: {
                                            emptyDataSourceMessage: (
                                                <Typography>
                                                    {labels.Nosurveystodisplay}
                                                </Typography>
                                            ),
                                        },
                                        toolbar: {
                                            searchPlaceholder: labels.Search
                                        },
                                        pagination: {
                                            labelRowsPerPage: labels.RowsPerPage,
                                            labelRowsSelect: labels.rows
                                        }
                                    }}
                                    style={{ width: "100%" }}
                                    title=""
                                    icons={tableIcons}
                                    columns={groupsColumns}
                                    options={{
                                        pageSizeOptions: [5, 10],
                                        defaultExpanded: true
                                    }}

                                    components={{
                                        OverlayLoading: props => (<div style={{ justifyContent: "center", alignItems: 'center' }}> {labels.Loading}... </div>)
                                    }}
                                    page={5}
                                    data={userData === null ? [] : userData}

                                    detailPanel={(rowData) => {

                                        return (
                                            <ThemeProvider theme={defaultMaterialTheme}>
                                                <MaterialTable
                                                    tableRef={tableRef}
                                                    localization={{
                                                        body: {
                                                            emptyDataSourceMessage: (
                                                                <Typography>
                                                                    No {labels.rows}
                                                                </Typography>
                                                            ),
                                                        },
                                                        toolbar: {
                                                            searchPlaceholder: labels.Search
                                                        },
                                                        pagination: {
                                                            labelRowsPerPage: labels.RowsPerPage,
                                                            labelRowsSelect: labels.rows
                                                        }
                                                    }}
                                                    style={{ width: "100%" }}
                                                    title=""
                                                    icons={tableIcons}
                                                    columns={ResultColumns}
                                                    options={{
                                                        pageSizeOptions: [5, 10],
                                                        defaultExpanded: true
                                                    }}

                                                    components={{
                                                        OverlayLoading: props => (<div style={{ justifyContent: "center", alignItems: 'center' }}> {labels.Loading}... </div>)
                                                    }}
                                                    page={5}
                                                    data={rowData.surveyDataToRender === null ? [] : rowData.surveyDataToRender}

                                                />
                                            </ThemeProvider>
                                        )

                                    }
                                    }
                                    onRowClick={(event, rowData, togglePanel) => togglePanel()}

                                />
                            </ThemeProvider>
                            <IonLoading
                                cssClass="my-custom-class"
                                isOpen={loading}
                                onDidDismiss={() => setLoading(false)}
                                message={`${labels.Pleasewait}...`}
                                duration={5000}
                            />
                        </IonCardContent>
                    )

                }



                <IonLoading
                    cssClass="my-custom-class"
                    isOpen={loading}
                    onDidDismiss={() => setLoading(false)}
                    message={`${labels.Pleasewait}...`}
                    duration={5000}
                />
            </IonContent>
        </IonPage >
    )


}